import React from 'react';
import type { IconProps } from './types';
import './style.css';

export const Icon: React.FC<IconProps> = ({ name, className, style }) => {
  return (
    <span
      style={{
        color: 'inherit',
        fontSize: 'inherit',
        ...style,
      }}
      className={`icon icon-${name} ${className}`}
    />
  );
};
